/* Aaramya theme interactions — header, home sections, product page and collection filters */
(() => {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- utilities ---------------- */
  let toastTimer;
  function toast(msg) {
    let el = $('.aar-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'aar-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  async function refreshCart(openDrawer = true) {
    let cart = null;
    try {
      const res = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      cart = await res.json();
    } catch (e) { /* ignore */ }
    const detail = { resource: cart || {}, sourceId: 'aaramya', data: { source: 'aaramya', itemCount: cart ? cart.item_count : 0 } };
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
    if (!openDrawer) return cart;
    const cartType = document.body.dataset.cartType || 'drawer';
    if (cartType === 'page') { window.location.href = root + 'cart'; return cart; }
    const drawer = $('cart-drawer-component');
    if (drawer) {
      setTimeout(() => {
        if (typeof drawer.open === 'function') drawer.open();
        else if (typeof drawer.showDialog === 'function') drawer.showDialog();
      }, 350);
    } else {
      toast('Added to cart');
    }
    return cart;
  }

  async function addToCart(items) {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
    return data;
  }

  /* ---------------- header ---------------- */
  function initHeader(scope = document) {
    $$('[data-aar-header]', scope).forEach((header) => {
      if (header.dataset.ready) return;
      header.dataset.ready = '1';
      const drawer = $('[data-aar-drawer]', header);
      const openBtn = $('[data-aar-drawer-open]', header);
      const setDrawer = (open) => {
        if (!drawer) return;
        drawer.classList.toggle('is-open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      openBtn && openBtn.addEventListener('click', () => setDrawer(true));
      $$('[data-aar-drawer-close]', header).forEach((b) => b.addEventListener('click', () => setDrawer(false)));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setDrawer(false); });

      $$('[data-aar-search-open]', header).forEach((a) => a.addEventListener('click', (e) => {
        const modal = document.getElementById('search-modal');
        if (modal && typeof modal.showDialog === 'function') {
          e.preventDefault();
          setDrawer(false);
          modal.showDialog();
        }
      }));

      /* mega menu (v1.4): the whole header bar + open panel is one hover zone, so the
         cursor can travel from the link down to the panel without it closing. */
      const navItems = $$('[data-aar-nav-item]', header);
      const items = navItems.filter((it) => it.querySelector('[data-aar-mega]'));
      const bar = $('.aar-header__bar', header) || header;
      let openTimer, closeTimer, lastPointer = 'mouse';
      const isDesktop = () => window.matchMedia('(min-width: 1200px)').matches;
      const setOpen = (item, open) => {
        items.forEach((it) => {
          const on = open && it === item;
          it.classList.toggle('is-open', on);
          const a = it.querySelector('.aar-nav__link');
          if (a) a.setAttribute('aria-expanded', String(on));
        });
      };
      const current = () => header.querySelector('.aar-nav__item.is-open');
      document.addEventListener('pointerdown', (e) => { lastPointer = e.pointerType || 'mouse'; }, { capture: true, passive: true });

      navItems.forEach((item) => {
        const isMega = items.includes(item);
        item.addEventListener('pointerenter', (e) => {
          if (e.pointerType !== 'mouse' || !isDesktop()) return;
          clearTimeout(closeTimer); clearTimeout(openTimer);
          if (!isMega) { openTimer = setTimeout(() => setOpen(null, false), 220); return; }
          const cur = current();
          if (cur === item) return;
          openTimer = setTimeout(() => setOpen(item, true), cur ? 140 : 80);
        });
        if (!isMega) return;
        const link = item.querySelector('.aar-nav__link');
        link.addEventListener('click', (e) => {
          if (lastPointer === 'mouse' || !isDesktop()) return; // mouse users follow the link
          if (!item.classList.contains('is-open')) { e.preventDefault(); setOpen(item, true); }
        });
        link.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || ((e.key === 'Enter' || e.key === ' ') && !item.classList.contains('is-open'))) {
            e.preventDefault(); setOpen(item, true);
            const first = item.querySelector('[data-aar-mega] a'); first && first.focus();
          }
        });
        item.addEventListener('focusout', (e) => { if (e.relatedTarget && !item.contains(e.relatedTarget)) setOpen(item, false); });
      });
      // logo / icons close it after a short pause; leaving the bar+panel closes it
      $$('.aar-header__logo, .aar-header__icons', header).forEach((el) => el.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer); clearTimeout(closeTimer);
        closeTimer = setTimeout(() => setOpen(null, false), 200);
      }));
      bar.addEventListener('pointerenter', (e) => { if (e.pointerType === 'mouse') clearTimeout(closeTimer); });
      bar.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(openTimer);
        closeTimer = setTimeout(() => setOpen(null, false), 280);
      });
      document.addEventListener('click', (e) => { if (!e.target.closest('[data-aar-nav-item]')) setOpen(null, false); });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        const open = current();
        if (open) { setOpen(null, false); open.querySelector('.aar-nav__link').focus(); }
      });
      window.addEventListener('scroll', () => { if (lastPointer !== 'mouse' && current()) setOpen(null, false); }, { passive: true });
      window.addEventListener('resize', () => { if (!isDesktop()) setOpen(null, false); });

      const sticky = header.dataset.sticky === 'true';
      if (!sticky) return;
      const overlay = header.classList.contains('is-overlay');
      let ticking = false;
      const onScroll = () => {
        const y = window.scrollY;
        header.classList.toggle('is-stuck', y > 10);
        if (overlay) header.classList.toggle('is-fixed', y > 260);
        ticking = false;
      };
      window.addEventListener('scroll', () => { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
      onScroll();
    });
  }

  /* ---------------- scroller dots (mobile sliders) ---------------- */
  function buildDots(track, dots) {
    if (!track || !dots) return;
    const items = Array.from(track.children).filter((el) => el.offsetParent !== null || el.getClientRects().length);
    dots.innerHTML = '';
    if (items.length < 2) return;
    items.forEach((item, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      b.addEventListener('click', () => track.scrollTo({ left: item.offsetLeft - track.offsetLeft, behavior: 'smooth' }));
      dots.appendChild(b);
    });
    const update = () => {
      const w = track.clientWidth || 1;
      const idx = Math.round(track.scrollLeft / (items[0].getBoundingClientRect().width + 12 || w));
      $$('button', dots).forEach((b, i) => b.classList.toggle('is-active', i === Math.min(idx, items.length - 1)));
    };
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
  }

  function initScrollers(scope = document) {
    $$('[data-aar-scroller]', scope).forEach((track) => {
      if (track.dataset.autoplay !== 'false') autoplay(track, 4000);
      const dots = track.parentElement.querySelector('[data-aar-dots]');
      if (dots && !dots.dataset.ready) {
        dots.dataset.ready = '1';
        buildDots(track, dots);
      }
    });
  }

  /* ---------------- hero thumbnails ---------------- */
  /* generic looping autoplay for horizontal tracks */
  function autoplay(track, interval = 3500) {
    if (!track || track.dataset.autoplayReady) return;
    track.dataset.autoplayReady = '1';
    let pauseUntil = 0;
    let visible = true;
    const pause = (ms = 6000) => { pauseUntil = Date.now() + ms; };
    track.addEventListener('mouseenter', () => pause(60 * 60 * 1000));
    track.addEventListener('mouseleave', () => pause(1500));
    track.addEventListener('touchstart', () => pause(7000), { passive: true });
    track.addEventListener('pointerdown', () => pause(7000));
    track.addEventListener('focusin', () => pause(10000));
    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => entries.forEach((en) => (visible = en.isIntersecting)), { threshold: 0.25 }).observe(track);
    }
    const tick = () => {
      if (Date.now() < pauseUntil || document.hidden || !visible) return;
      if (!track.isConnected || track.offsetParent === null) return;
      if (track.scrollWidth <= track.clientWidth + 4) return;
      const items = Array.from(track.children).filter((el) => el.getClientRects().length);
      if (!items.length) return;
      const cs = getComputedStyle(track);
      const gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
      const step = items[0].getBoundingClientRect().width + gap;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 6;
      track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
    };
    setInterval(tick, interval);
  }

  function initHero(scope = document) {
    $$('[data-aar-hero-track]', scope).forEach((track) => {
      if (track.dataset.autoplay !== 'true') return;
      autoplay(track, 3500);
    });
  }

  /* ---------------- chair quiz ---------------- */
  function initQuiz(scope = document) {
    $$('[data-aar-quiz]', scope).forEach((quiz) => {
      if (quiz.dataset.ready) return;
      quiz.dataset.ready = '1';
      const steps = $$('[data-step]', quiz);
      const bars = $$('.aar-quiz__progress span', quiz);
      const back = $('[data-quiz-back]', quiz);
      const restart = $('[data-quiz-restart]', quiz);
      const title = $('[data-quiz-title]', quiz);
      const text = $('[data-quiz-text]', quiz);
      const productBox = $('[data-quiz-product]', quiz);
      const defaults = { title: title.textContent, text: text.textContent };
      let results = [];
      try { results = JSON.parse($('[data-quiz-results]', quiz).textContent); } catch (e) { results = []; }
      const matchQ = Math.max(1, parseInt(quiz.dataset.matchQuestion, 10) || steps.length) - 1;
      const answers = [];
      let current = 0;

      const show = (i) => {
        current = i;
        steps.forEach((s, k) => (s.hidden = k !== i));
        bars.forEach((b, k) => b.classList.toggle('is-done', k <= Math.min(i, steps.length - 1)));
        back.hidden = i === 0;
        restart.hidden = answers.length === 0;
      };

      const finish = () => {
        steps.forEach((s) => (s.hidden = true));
        steps[steps.length - 1].hidden = false;
        bars.forEach((b) => b.classList.add('is-done'));
        const ans = answers[Math.min(matchQ, answers.length - 1)];
        const r = results.find((x) => String(x.match).split(',').map((v) => v.trim()).includes(String(ans))) || results[0];
        if (!r) return;
        const parts = answers.map((a, k) => {
          const btn = $$('[data-option]', steps[k])[a - 1];
          return btn ? btn.textContent.trim() : '';
        });
        title.textContent = r.title || r.name || 'Your Aaramya chair';
        text.textContent = r.text ? r.text : 'Based on ' + parts.filter(Boolean).join(', ').toLowerCase() + ', this is our pick for you.';
        if (r.url) {
          productBox.innerHTML = '';
          if (r.image) {
            const img = document.createElement('img');
            img.src = r.image; img.alt = ''; img.loading = 'lazy';
            productBox.appendChild(img);
          }
          const info = document.createElement('div');
          info.className = 'aar-quiz__product-info';
          const b = document.createElement('b'); b.textContent = r.name || r.title || '';
          info.appendChild(b);
          if (r.price) { const p = document.createElement('span'); p.textContent = r.price; info.appendChild(p); }
          productBox.appendChild(info);
          const a = document.createElement('a');
          a.href = r.url; a.className = 'aar-btn aar-btn--primary'; a.textContent = 'View chair';
          productBox.appendChild(a);
          productBox.classList.add('is-visible');
        }
        restart.hidden = false;
        back.hidden = false;
      };

      quiz.addEventListener('click', (e) => {
        const opt = e.target.closest('[data-option]');
        if (!opt) return;
        const stepEl = opt.closest('[data-step]');
        const idx = parseInt(stepEl.dataset.step, 10);
        $$('[data-option]', stepEl).forEach((o) => o.classList.toggle('is-selected', o === opt));
        answers[idx] = parseInt(opt.dataset.option, 10);
        answers.length = idx + 1;
        if (idx < steps.length - 1) setTimeout(() => show(idx + 1), 180);
        else finish();
      });
      back.addEventListener('click', () => {
        productBox.classList.remove('is-visible');
        title.textContent = defaults.title; text.textContent = defaults.text;
        if (answers.length === steps.length) {
          answers.length = steps.length - 1;
          show(steps.length - 1);
        } else {
          const to = Math.max(0, current - 1);
          answers.length = to;
          show(to);
        }
      });
      restart.addEventListener('click', () => {
        answers.length = 0;
        $$('.is-selected', quiz).forEach((o) => o.classList.remove('is-selected'));
        productBox.classList.remove('is-visible');
        title.textContent = defaults.title; text.textContent = defaults.text;
        show(0);
      });
      show(0);
    });
  }

  /* ---------------- sit / stand ---------------- */
  function initSit(scope = document) {
    $$('[data-aar-sit]', scope).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      sec.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-sit-tab]');
        if (!tab) return;
        const i = tab.dataset.sitTab;
        $$('[data-sit-tab]', sec).forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
        $$('[data-sit-panel]', sec).forEach((p) => p.classList.toggle('is-active', p.dataset.sitPanel === i));
      });
    });
  }

  /* ---------------- simple tabs (browse range) ---------------- */
  function initTabs(scope = document) {
    $$('[data-aar-tabs]', scope).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      sec.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-tab]');
        if (!tab || !sec.contains(tab)) return;
        $$('[data-tab]', sec).forEach((t) => { const on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); });
        $$('[data-panel]', sec).forEach((p) => (p.hidden = p.dataset.panel !== tab.dataset.tab));
      });
    });
  }

  /* ---------------- compare ---------------- */
  function initCompare(scope = document) {
    $$('[data-aar-compare]', scope).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const max = parseInt(sec.dataset.max, 10) || 3;
      const min = parseInt(sec.dataset.min, 10) || 2;
      const msg = $('[data-compare-msg]', sec);
      const boxes = $$('input[type="checkbox"]', sec);
      const apply = () => {
        const on = boxes.filter((b) => b.checked).map((b) => b.value);
        $$('[data-col]', sec).forEach((c) => (c.hidden = !on.includes(c.dataset.col)));
      };
      boxes.forEach((b) => b.addEventListener('change', () => {
        const count = boxes.filter((x) => x.checked).length;
        msg.textContent = '';
        if (count > max) { b.checked = false; msg.textContent = 'You can compare up to ' + max + ' chairs.'; }
        if (count < min) { b.checked = true; msg.textContent = 'Pick at least ' + min + ' chairs to compare.'; }
        apply();
      }));
      sec.aarSelect = (handle) => {
        const box = boxes.find((b) => b.dataset.handle === handle);
        if (!box) return false;
        if (!box.checked) {
          const on = boxes.filter((b) => b.checked);
          if (on.length >= max) on[on.length - 1].checked = false;
          box.checked = true;
          apply();
        }
        return true;
      };
      apply();
    });
  }

  document.addEventListener('click', (e) => {
    const pick = e.target.closest('[data-aar-compare-pick]');
    if (!pick) return;
    const sec = $('[data-aar-compare]');
    if (!sec) return;
    if (sec.aarSelect) sec.aarSelect(pick.dataset.aarComparePick);
    sec.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  });

  /* ---------------- testimonials ---------------- */
  function initTesti(scope = document) {
    $$('[data-aar-testi]', scope).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const cards = $$('.aar-testi__card', sec);
      const dots = $$('[data-go]', sec);
      if (cards.length < 2) return;
      let i = 0;
      const go = (n) => {
        i = (n + cards.length) % cards.length;
        cards.forEach((c, k) => c.classList.toggle('is-active', k === i));
        dots.forEach((d, k) => { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', String(k === i)); });
      };
      dots.forEach((d) => d.addEventListener('click', () => go(parseInt(d.dataset.go, 10))));
      let sx = null;
      sec.addEventListener('touchstart', (e) => (sx = e.touches[0].clientX), { passive: true });
      sec.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
        sx = null;
      });
      if (sec.dataset.autoplay === 'true') {
        let hover = false;
        sec.addEventListener('mouseenter', () => (hover = true));
        sec.addEventListener('mouseleave', () => (hover = false));
        let touchPause = 0;
        sec.addEventListener('touchstart', () => (touchPause = Date.now() + 8000), { passive: true });
        setInterval(() => { if (!hover && !document.hidden && Date.now() > touchPause) go(i + 1); }, 5000);
      }
    });
  }

  /* ---------------- product slider ---------------- */
  function bindSlider(sec) {
    const prev = $('[data-prev]', sec);
    const next = $('[data-next]', sec);
    const activeTrack = () => { const p = $$('[data-panel]', sec).find((x) => !x.hidden); return p ? $('[data-track]', p) : null; };
    const update = () => {
      const t = activeTrack();
      if (!t || !prev) return;
      prev.disabled = t.scrollLeft <= 2;
      next.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
    };
    const move = (dir) => {
      const t = activeTrack();
      if (!t || !t.children[0]) return;
      const w = t.children[0].getBoundingClientRect().width + 20;
      t.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    prev && prev.addEventListener('click', () => move(-1));
    next && next.addEventListener('click', () => move(1));
    $$('[data-track]', sec).forEach((t) => t.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true }));
    sec.addEventListener('click', (e) => {
      const tab = e.target.closest('[data-tab]');
      if (!tab) return;
      $$('[data-tab]', sec).forEach((t) => t.classList.toggle('is-active', t === tab));
      $$('[data-panel]', sec).forEach((p) => (p.hidden = p.dataset.panel !== tab.dataset.tab));
      update();
    });
    update();
  }

  function initProductSliders(scope = document) {
    $$('[data-aar-pslider]', scope).forEach(async (sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      const reco = sec.dataset.recoUrl;
      if (reco) {
        try {
          const html = await (await fetch(reco)).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-aar-pslider] [data-track]');
          const track = $('[data-track]', sec);
          if (fresh && fresh.children.length) track.innerHTML = fresh.innerHTML;
          else sec.closest('.shopify-section') ? (sec.closest('.shopify-section').style.display = 'none') : (sec.style.display = 'none');
        } catch (e) { /* keep empty */ }
      }
      bindSlider(sec);
      if (sec.dataset.autoplay !== 'false') $$('[data-track]', sec).forEach((t) => autoplay(t, 4000));
    });
  }

  /* ---------------- add to cart buttons ---------------- */
  document.addEventListener('click', async (e) => {
    const single = e.target.closest('[data-aar-add]');
    const many = e.target.closest('[data-aar-add-many]');
    const btn = single || many;
    if (!btn) return;
    e.preventDefault();
    const ids = (single ? single.dataset.aarAdd : many.dataset.aarAddMany).split(',').map((x) => x.trim()).filter(Boolean);
    if (!ids.length) { toast('Nothing to add'); return; }
    btn.classList.add('is-loading');
    try {
      await addToCart(ids.map((id) => ({ id: Number(id), quantity: 1 })));
      await refreshCart(true);
    } catch (err) {
      toast(err.message);
    } finally {
      btn.classList.remove('is-loading');
    }
  });

  /* ---------------- quick view ---------------- */
  async function openQuickView(handle) {
    let modal = $('.aar-qv');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'aar aar-qv';
      modal.innerHTML = '<div class="aar-qv__overlay" data-qv-close></div><div class="aar-qv__panel" role="dialog" aria-modal="true" aria-label="Quick view"><button type="button" class="aar-qv__close" data-qv-close aria-label="Close">&times;</button><div class="aar-qv__body"></div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', (ev) => { if (ev.target.closest('[data-qv-close]')) modal.classList.remove('is-open'); });
      document.addEventListener('keydown', (ev) => { if (ev.key === 'Escape') modal.classList.remove('is-open'); });
    }
    const body = $('.aar-qv__body', modal);
    body.innerHTML = '<p style="padding:40px;text-align:center">Loading…</p>';
    modal.classList.add('is-open');
    try {
      const p = await (await fetch(root + 'products/' + handle + '.js')).json();
      const fmt = (c) => {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'INR', maximumFractionDigits: 2 }).format(c / 100); } catch (x) { return (c / 100).toFixed(2); }
      };
      const v0 = p.variants.find((v) => v.available) || p.variants[0];
      const opts = p.variants.length > 1 ? '<label class="aar-qv__label">Option<select data-qv-variant>' + p.variants.map((v) => '<option value="' + v.id + '"' + (v.id === v0.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + v.title + (v.available ? '' : ' — sold out') + '</option>').join('') + '</select></label>' : '';
      const img = (p.featured_image || '').replace(/(\.[a-z]+)(\?|$)/i, '$1$2');
      body.innerHTML =
        '<div class="aar-qv__media">' + (img ? '<img src="' + img + (img.includes('?') ? '&' : '?') + 'width=800" alt="">' : '') + '</div>' +
        '<div class="aar-qv__info"><h3 class="aar-qv__title">' + p.title + '</h3>' +
        '<p class="aar-qv__price" data-qv-price>' + fmt(v0.price) + (v0.compare_at_price > v0.price ? ' <s>' + fmt(v0.compare_at_price) + '</s>' : '') + '</p>' +
        opts +
        '<button type="button" class="aar-buy__atc" data-qv-add' + (v0.available ? '' : ' disabled') + '>Add to cart</button>' +
        '<a href="' + p.url + '" class="aar-link">View full details</a></div>';
      const sel = $('[data-qv-variant]', body);
      const add = $('[data-qv-add]', body);
      sel && sel.addEventListener('change', () => {
        const v = p.variants.find((x) => String(x.id) === sel.value);
        $('[data-qv-price]', body).innerHTML = fmt(v.price) + (v.compare_at_price > v.price ? ' <s>' + fmt(v.compare_at_price) + '</s>' : '');
        add.disabled = !v.available;
      });
      add.addEventListener('click', async () => {
        add.classList.add('is-loading');
        try {
          await addToCart([{ id: Number(sel ? sel.value : v0.id), quantity: 1 }]);
          modal.classList.remove('is-open');
          await refreshCart(true);
        } catch (err) { toast(err.message); } finally { add.classList.remove('is-loading'); }
      });
    } catch (err) {
      window.location.href = root + 'products/' + handle;
    }
  }
  document.addEventListener('click', (e) => {
    const qv = e.target.closest('[data-aar-quickview]');
    if (!qv) return;
    e.preventDefault();
    openQuickView(qv.dataset.aarQuickview);
  });

  /* ---------------- product page ---------------- */
  function initProduct(scope = document) {
    $$('[data-aar-product]', scope).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      let data = null;
      try { data = JSON.parse($('[data-product-json]', sec).textContent); } catch (e) { return; }

      /* gallery dots (mobile) + lightbox */
      const gallery = $('[data-aar-gallery]', sec);
      const gDots = $('[data-aar-dots-for="gallery"]', sec);
      if (gallery && gDots) buildDots(gallery, gDots);
      const lb = $('[data-aar-lightbox]', sec);
      const zoomables = $$('[data-zoom]', sec);
      let lbIndex = 0;
      const lbShow = (i) => {
        lbIndex = (i + zoomables.length) % zoomables.length;
        const img = $('[data-lb-img]', lb);
        img.src = zoomables[lbIndex].dataset.zoom;
        img.alt = ($('img', zoomables[lbIndex]) || {}).alt || '';
        lb.classList.add('is-open');
        lb.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      };
      const lbClose = () => { lb.classList.remove('is-open'); lb.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
      zoomables.forEach((z, i) => z.addEventListener('click', () => lbShow(i)));
      if (lb) {
        $('[data-lb-close]', lb).addEventListener('click', lbClose);
        $('[data-lb-prev]', lb).addEventListener('click', () => lbShow(lbIndex - 1));
        $('[data-lb-next]', lb).addEventListener('click', () => lbShow(lbIndex + 1));
        lb.addEventListener('click', (e) => { if (e.target === lb) lbClose(); });
        document.addEventListener('keydown', (e) => {
          if (!lb.classList.contains('is-open')) return;
          if (e.key === 'Escape') lbClose();
          if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
          if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
        });
      }

      /* variants */
      const form = $('form[action*="/cart/add"]', sec);
      const idInput = form ? $('[data-variant-input]', form) : null;
      const priceEl = $('[data-price]', sec);
      const compareEl = $('[data-compare]', sec);
      const compareAmt = $('[data-compare-amount]', sec);
      const badge = $('[data-badge]', sec);
      const atc = $('[data-atc]', sec);
      const atcText = $('[data-atc-text]', sec);
      const atcLabel = atcText ? atcText.textContent.trim() : 'Add to cart';
      const skuWrap = $('[data-sku]', sec);

      const currentOptions = () => $$('[data-option-index]', sec).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
      const findVariant = (opts) => data.variants.find((v) => v.options.every((o, i) => opts[i] == null || o === opts[i]));

      const markAvailability = (opts) => {
        $$('[data-option-index]', sec).forEach((fs) => {
          const idx = parseInt(fs.dataset.optionIndex, 10);
          $$('input', fs).forEach((inp) => {
            const test = opts.slice(); test[idx] = inp.value;
            const ok = data.variants.some((v) => v.available && v.options.every((o, i) => o === test[i]));
            inp.classList.toggle('is-unavailable', !ok);
          });
          const sel = $('[data-selected-value]', fs);
          const c = $('input:checked', fs);
          if (sel && c) sel.textContent = c.value;
        });
      };

      const applyVariant = (v) => {
        if (!v) {
          if (atc) { atc.disabled = true; if (atcText) atcText.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        if (priceEl) priceEl.textContent = v.price;
        if (compareEl) { compareEl.hidden = !v.compare; if (compareAmt && v.compare) compareAmt.textContent = v.compare; }
        if (badge) { badge.hidden = !v.off; badge.textContent = v.off + (badge.dataset.suffix || '% OFF'); }
        if (atc) { atc.disabled = !v.available; if (atcText) atcText.textContent = v.available ? atcLabel : 'Sold out'; }
        if (skuWrap) { skuWrap.hidden = !v.sku; const sv = $('[data-sku-value]', skuWrap); if (sv) sv.textContent = v.sku || ''; }
        if (v.media && gallery) {
          const item = $('[data-media-id="' + v.media + '"]', gallery);
          if (item) {
            if (window.matchMedia('(min-width: 990px)').matches) {
              if (item !== gallery.firstElementChild) {
                gallery.insertBefore(item, gallery.firstElementChild);
              }
            } else {
              gallery.scrollTo({ left: item.offsetLeft - gallery.offsetLeft, behavior: 'smooth' });
            }
          }
        }
        if (sec.dataset.updateUrl === 'true') {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        document.dispatchEvent(new CustomEvent('aaramya:variant-change', { detail: { variantId: v.id, productId: data.id } }));
      };

      $$('[data-option-index] input', sec).forEach((inp) => inp.addEventListener('change', () => {
        const opts = currentOptions();
        let v = findVariant(opts);
        if (!v || !v.available) {
          const changedIdx = parseInt(inp.closest('[data-option-index]').dataset.optionIndex, 10);
          const alt = data.variants.find((x) => x.available && x.options[changedIdx] === inp.value);
          if (alt && !v) {
            $$('[data-option-index]', sec).forEach((fs, i) => {
              const target = $$('input', fs).find((x) => x.value === alt.options[i]);
              if (target) target.checked = true;
            });
            v = alt;
          }
        }
        markAvailability(currentOptions());
        applyVariant(v);
      }));
      if ($$('[data-option-index]', sec).length) markAvailability(currentOptions());

      /* quantity */
      $$('[data-qty]', sec).forEach((b) => b.addEventListener('click', () => {
        const input = $('input[name="quantity"]', b.parentElement);
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.qty, 10));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));

      /* add to cart */
      if (form) {
        const err = $('[data-atc-error]', sec);
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (!atc || atc.disabled) return;
          atc.classList.add('is-loading');
          if (err) err.hidden = true;
          try {
            const fd = new FormData(form);
            const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
            const json = await res.json();
            if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add to cart');
            await refreshCart(true);
          } catch (ex) {
            if (err) { err.textContent = ex.message; err.hidden = false; }
          } finally {
            atc.classList.remove('is-loading');
          }
        });
      }

      /* share */
      const share = $('[data-aar-share]', sec);
      share && share.addEventListener('click', async () => {
        const url = window.location.href;
        if (navigator.share) {
          try { await navigator.share({ title: share.dataset.title, url }); return; } catch (x) { /* fall through */ }
        }
        try { await navigator.clipboard.writeText(url); } catch (x) { /* ignore */ }
        const m = $('[data-share-msg]', share);
        if (m) { m.classList.add('is-visible'); setTimeout(() => m.classList.remove('is-visible'), 1800); }
      });

      /* delivery timeline */
      $$('[data-aar-timeline]', sec).forEach((tl) => {
        const skipSun = tl.dataset.skipSunday === 'true';
        const addDays = (d, n) => { const x = new Date(d); let added = 0; while (added < n) { x.setDate(x.getDate() + 1); if (!(skipSun && x.getDay() === 0)) added++; } return x; };
        const f = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        const now = new Date();
        const sMin = addDays(now, +tl.dataset.shipMin || 0);
        const sMax = addDays(now, +tl.dataset.shipMax || 0);
        const dMin = addDays(now, +tl.dataset.deliverMin || 0);
        const dMax = addDays(now, +tl.dataset.deliverMax || 0);
        const set = (k, txt) => { const el = $('[data-tl="' + k + '"]', tl); if (el) el.textContent = txt; };
        set('placed', f(now));
        set('shipped', +tl.dataset.shipMin === +tl.dataset.shipMax ? f(sMin) : f(sMin) + ' - ' + f(sMax));
        set('delivered', +tl.dataset.deliverMin === +tl.dataset.deliverMax ? f(dMin) : f(dMin) + ' - ' + f(dMax));
      });
    });
  }

  /* ---------------- product tabs ---------------- */
  function initProductTabs(scope = document) {
    $$('[data-aar-ptabs]', scope).forEach((sec) => {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      sec.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-tab]');
        if (!btn) return;
        $$('[data-tab]', sec).forEach((b) => { const on = b === btn; b.classList.toggle('is-active', on); b.setAttribute('aria-selected', String(on)); });
        $$('[data-panel]', sec).forEach((p) => (p.hidden = p.dataset.panel !== btn.dataset.tab));
      });
    });
  }

  /* ---------------- collection filters ---------------- */
  function initCollection(scope = document) {
    $$('[data-aar-collection]', scope).forEach((wrap) => {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';
      const sectionId = wrap.dataset.section;
      const baseUrl = wrap.dataset.url;
      let controller;

      const applyCols = (n) => {
        const grid = $('[data-aar-grid]', wrap);
        if (grid && n) grid.style.setProperty('--cols', n);
        $$('[data-cols]', wrap).forEach((b) => b.classList.toggle('is-active', b.dataset.cols === String(n)));
      };
      let savedCols = null;
      try { savedCols = localStorage.getItem('aar-cols'); } catch (e) { /* ignore */ }
      if (savedCols) applyCols(savedCols);
      wrap.addEventListener('click', (e) => {
        const b = e.target.closest('[data-cols]');
        if (!b) return;
        applyCols(b.dataset.cols);
        try { localStorage.setItem('aar-cols', b.dataset.cols); } catch (x) { /* ignore */ }
      });

      const panel = $('[data-filters-panel]', wrap);
      const overlay = $('.aar-filters__overlay', wrap);
      const setPanel = (open) => {
        if (!panel) return;
        panel.classList.toggle('is-open', open);
        overlay && overlay.classList.toggle('is-open', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      wrap.addEventListener('click', (e) => {
        if (e.target.closest('[data-filters-open]')) setPanel(true);
        if (e.target.closest('[data-filters-close]')) setPanel(false);
      });

      const render = async (url, push = true) => {
        if (controller) controller.abort();
        controller = new AbortController();
        const results = $('[data-aar-coll-results]', wrap);
        results && results.classList.add('is-loading');
        const u = new URL(url, window.location.origin);
        u.searchParams.set('section_id', sectionId);
        try {
          const html = await (await fetch(u.toString(), { signal: controller.signal })).text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const fresh = doc.querySelector('[data-aar-collection]');
          if (!fresh) { window.location.href = url; return; }
          const newResults = $('[data-aar-coll-results]', fresh);
          if (newResults && results) results.innerHTML = newResults.innerHTML;
          const newForm = $('[data-aar-filter-form]', fresh);
          const form = $('[data-aar-filter-form]', wrap);
          if (newForm && form) {
            const openState = $$('details', form).map((d) => d.open);
            form.innerHTML = newForm.innerHTML;
            $$('details', form).forEach((d, i) => { if (openState[i] !== undefined) d.open = openState[i] || d.open; });
          }
          const cols = (() => { try { return localStorage.getItem('aar-cols'); } catch (x) { return null; } })();
          if (cols) applyCols(cols);
          u.searchParams.delete('section_id');
          if (push) history.pushState({ aar: true }, '', u.toString());
        } catch (e) {
          if (e.name !== 'AbortError') window.location.href = url;
        } finally {
          results && results.classList.remove('is-loading');
        }
      };

      const formUrl = () => {
        const form = $('[data-aar-filter-form]', wrap);
        const params = new URLSearchParams();
        if (form) new FormData(form).forEach((v, k) => { if (String(v).trim() !== '') params.append(k, v); });
        const sort = $('[data-aar-sort]', wrap);
        if (sort) params.set('sort_by', sort.value);
        return baseUrl + '?' + params.toString();
      };

      let priceTimer;
      wrap.addEventListener('change', (e) => {
        if (e.target.matches('[data-aar-sort]')) {
          const hidden = $('[data-sort-hidden]', wrap);
          if (hidden) hidden.value = e.target.value;
          render(formUrl());
          return;
        }
        if (!e.target.closest('[data-aar-filter-form]')) return;
        if (e.target.matches('[data-price-input]')) {
          clearTimeout(priceTimer);
          priceTimer = setTimeout(() => render(formUrl()), 500);
          return;
        }
        render(formUrl());
      });
      wrap.addEventListener('submit', (e) => {
        if (!e.target.matches('[data-aar-filter-form]')) return;
        e.preventDefault();
        render(formUrl());
      });
      wrap.addEventListener('click', (e) => {
        const a = e.target.closest('a[data-aar-link]');
        if (!a) return;
        e.preventDefault();
        render(a.href);
        if (a.closest('.aar-pager')) wrap.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      });
      window.addEventListener('popstate', () => render(window.location.href, false));
    });
  }

  /* ---------------- boot ---------------- */
  function initAll(scope = document) {
    [initHeader, initScrollers, initHero, initQuiz, initSit, initTabs, initCompare, initTesti, initProductSliders, initProduct, initProductTabs, initCollection].forEach((fn) => {
      try { fn(scope); } catch (err) { console.error('[Aaramya] ' + fn.name + ' failed', err); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  window.addEventListener('load', () => initAll());

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  window.Aaramya = { refreshCart, addToCart, toast };
})();
 